var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodOrderpvr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4 60 10-10 16 16-10 10L4 60Z",
    fill: "#FFCB05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16 52 4-3c3-3 5-5 10-5h13a4 4 0 1 1 0 7h11l6-6a4 4 0 1 1 5 5l-6 6c-1 1-3 3-5 3H36l-6 2-2 3-12-12Z",
    fill: "#FDD5A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM76 39c0 3-2 5-5 5H19c-3 0-5-2-5-5h62Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 39c0-17 10-28 27-28s28 11 28 28H18Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 4h-1a5 5 0 0 1 0 7 4 4 0 0 0 5-4c0-2-2-3-4-3Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m64 44-1 3-7 7-6 2H33c-3 0-4 1-6 3l-2 2 3 3 2-3 6-2h18c2 0 4-2 5-3l6-6a4 4 0 0 0-1-6Z",
    fill: "#FDCC93"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27 64 17 74l3 2 10-10-3-2Z",
    fill: "#E8B800"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51 12c4 1 7 3 10 6 5 5 8 12 8 21h4c0-15-9-25-22-27Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m72 39-2 5h1c3 0 5-2 5-5h-4Z",
    fill: "#CFD7DF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M45 2c-3 0-5 3-5 5l1 3c-7 1-13 4-17 8-5 5-7 11-8 19h-2c-1 0-2 1-1 2 0 3 2 6 6 6h3l-3 3-3 3-1-2h-2L3 59v2l16 16h2l10-10v-2l-2-1 2-2c1-1 2-2 5-2h18c3 0 5-2 6-3l6-6c2-2 2-4 1-6h4c4 0 6-3 6-6 1-1 0-2-1-2h-2c-1-8-3-14-8-19-4-4-10-7-17-8l1-3c0-2-2-5-5-5Zm0 3 3 2c0 2-2 3-3 3s-3-1-3-3l3-2Zm0 7c8 0 15 3 19 8 4 4 7 10 7 17h-7c-2 0-2 3 0 3h11c-1 2-2 2-4 2H19c-2 0-3 0-4-2h38v-3H19c0-7 3-13 7-17 4-5 11-8 19-8Zm13 25c-2 0-2 3 0 3h1v-3h-1Zm-28 8h13l2 2c0 2-1 3-2 3h-9c-2 0-2 3 0 2h21l6-6h3v3l-6 6-4 2H36c-3 0-6 2-7 3l-1 2-10-10 3-2c2-3 4-5 9-5Zm17 0h11l-5 5h-6l1-3-1-2Zm-33 7 14 14-8 8L6 60l8-8Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodOrderpvr);
export default __webpack_public_path__ + "static/media/foodOrderpvr.8e1cc206b9d501ebeef17040d739ec26.svg";
export { ForwardRef as ReactComponent };